import {ChangeDetectorRef, Component, Inject, ViewChild, ViewContainerRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DetailPopup} from '../../../mapping-classes/detail-popup';
import {DetailPopupRequestModel} from '../../../services/popup/detail-popup-request.model';
import * as DetailTable from '../../../table-lib';
import {DomService} from '../../../../../../services/dom-service/dom.service';
import {DebitInterestTableComponent} from '../../../detail-table/debit-interest/debit-interest-table.component';
import {LinkIdTableComponent} from '../../../detail-table/link-id/link-id-table.component';

@Component({
             selector: 'app-detail-table',
             templateUrl: './debit-interest-popup.component.html',
             styleUrls: ['../../../detail-screen/detail-screen.component.css'],
           })

export class DebitInterestPopupComponent implements DetailPopup {
  @ViewChild('table', {read: ViewContainerRef}) tableContainer: ViewContainerRef;
  @ViewChild('link_id_table', {read: ViewContainerRef}) linkIdTableContainer: ViewContainerRef;

  title: string;
  restrictedData: boolean;
  errorText: string;
  hasData = true;
  data;
  tableInstance;
  tableComponent;
  linkIdTableComponent;
  expanded = false;
  emptyValuePlaceholder = '-';

  constructor(private domService: DomService, private changeRef: ChangeDetectorRef,
              public dialogRef: MatDialogRef<DebitInterestPopupComponent>,
              @Inject(MAT_DIALOG_DATA) public inputData: any) {
    this.title = 'Debetrente afspraken tabel: ' + DetailPopupRequestModel.tableNumber;

    if (inputData.listOfError && inputData.listOfError.length !== 0) {
      this.createErrorMessage(inputData);
      this.hasData = false;
    } else if (inputData && inputData.detailsViewObject) {
      this.data = inputData;
      this.restrictedData = inputData.detailsViewObject['restrictedData'];
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  ngAfterViewInit() {
    this.addValues(this.data);
    this.changeRef.detectChanges();
  }

  onClick() {
    this.expanded = !this.expanded;
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.title = 'Debetrente afspraken';
        this.errorText = 'Debetrente afspraken niet gevonden.';
      }
    }
  }

  addValues(response) {
    const detailsViewObject = response.detailsViewObject;
    this.createTable(detailsViewObject);
    this.createLinkIdTable(detailsViewObject);
  }

  private createTable(detailsViewObject) {
    this.tableInstance = new DetailTable['Debitinterest'](detailsViewObject);
    if (!this.tableContainer) {
      return null;
    }
    this.tableComponent = this.createDebitInterestTable();
  }

  private createDebitInterestTable() {
    const viewRef = this.domService.addComponentToDOM(DebitInterestTableComponent, this.tableContainer);
    const tableComponentToReturn = viewRef.instance as DebitInterestTableComponent;
    return this.setBasicComponentValues(tableComponentToReturn);
  }

  private setBasicComponentValues(componentToReturn) {
    componentToReturn.errorText = this.tableInstance.errorText;
    componentToReturn.showTable = (componentToReturn.errorText === null || componentToReturn.errorText === undefined);
    componentToReturn.restrictedData = this.restrictedData;
    componentToReturn.tableColumns = this.tableInstance.rowHeaders;
    componentToReturn.tableData = this.tableInstance.rowData;
    return componentToReturn;
  }

  private createLinkIdTable(detailsViewObject) {
    this.tableInstance = new DetailTable['Linkids'](detailsViewObject);
    if (!this.linkIdTableContainer) {
      return null;
    }
    this.linkIdTableComponent = this.createLinkIdTableComponent();
  }

  private createLinkIdTableComponent() {
    const viewRef = this.domService.addComponentToDOM(LinkIdTableComponent, this.linkIdTableContainer);
    const tableComponentToReturn = viewRef.instance as LinkIdTableComponent;
    return this.setBasicComponentValues(tableComponentToReturn);
  }
}
